/** 백엔드 PENDING_EXPIRE_DAYS 와 동일 */
export const PENDING_EXPIRE_DAYS = 3
/** 백엔드 AUTO_CONFIRM_DAYS 와 동일 */
export const AUTO_CONFIRM_DAYS = 7

/** 입금대기 만료까지 남은 일수 (음수면 기한 초과) */
export function pendingExpireDaysLeft(orderedAt: string, now = Date.now()): number {
  const start = new Date(orderedAt).getTime()
  if (!Number.isFinite(start)) return PENDING_EXPIRE_DAYS
  const expireAt = start + PENDING_EXPIRE_DAYS * 24 * 60 * 60 * 1000
  return Math.ceil((expireAt - now) / (24 * 60 * 60 * 1000))
}

/** 회원·관리자 목록용 짧은 입금기한 라벨 */
export function pendingExpireLabel(orderedAt: string): string {
  const left = pendingExpireDaysLeft(orderedAt)
  if (left > 1) return `입금 기한 D-${left}`
  if (left === 1) return '입금 기한 내일까지'
  if (left === 0) return '입금 기한 오늘까지'
  return '입금 기한 임박·만료 예정'
}

export function pendingExpireTone(orderedAt: string): 'ok' | 'warn' | 'alert' {
  const left = pendingExpireDaysLeft(orderedAt)
  if (left <= 0) return 'alert'
  if (left === 1) return 'warn'
  return 'ok'
}

export function autoConfirmDaysLeft(deliveredAt: string, now = Date.now()): number {
  const start = new Date(deliveredAt).getTime()
  if (!Number.isFinite(start)) return AUTO_CONFIRM_DAYS
  const confirmAt = start + AUTO_CONFIRM_DAYS * 24 * 60 * 60 * 1000
  return Math.ceil((confirmAt - now) / (24 * 60 * 60 * 1000))
}

export function autoConfirmLabel(deliveredAt: string): string {
  const left = autoConfirmDaysLeft(deliveredAt)
  if (left > 1) return `${left}일 뒤 자동 구매확정`
  if (left === 1) return '내일 자동 구매확정'
  if (left === 0) return '오늘 자동 구매확정'
  return '자동 구매확정 예정'
}
